import { useLocation, useParams } from 'react-router-dom';
import { RoutePaths } from '../../routes/RoutePaths';
import {
    StyledCandidatesPageWrap,
    StyledTableContainer,
} from './JobApplicationsPage.styles';
import { JobApplicationsTable } from '../../components/Tables';
import JobApplicationEntity from '../../components/JobApplicationEntity';
import ApplicationsPageStatistics from '../../components/ApplicationsPageStatistics';
import RejectApplicationModal from '../../components/JobApplicationEntity/RejectApplicationModal';
import BulkRejectApplicationModal from '../../components/JobApplicationEntity/BulkRejectApplicationModal';
import TransferCandidateModal from '../../components/JobApplicationEntity/TransferCandidateModal';

const JobApplicationsPage = () => {
    const location = useLocation();
    const { id } = useParams();
    const path = location.pathname;
    const isEntityPath =
        path?.replace(/\/+$/, '') !== RoutePaths.jobApplications;
    return (
        <>
            {isEntityPath && <JobApplicationEntity applicationId={id || '0'} />}
            <StyledCandidatesPageWrap isEntityPath={isEntityPath}>
                <ApplicationsPageStatistics />
                <StyledTableContainer>
                    <JobApplicationsTable />
                </StyledTableContainer>
            </StyledCandidatesPageWrap>
            <RejectApplicationModal />
            <BulkRejectApplicationModal />
            <TransferCandidateModal />
        </>
    );
};

export default JobApplicationsPage;
